import { useEffect, useState } from 'react';

const MOBILE_QUERY = '(max-width: 767px)';
const PHONE_QUERY = '(max-width: 639px)';

export function useIsMobile(): boolean {
  return useMediaQuery(MOBILE_QUERY);
}

export function useIsPhone(): boolean {
  return useMediaQuery(PHONE_QUERY);
}

function useMediaQuery(query: string): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    if (typeof window.matchMedia !== 'function') return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    if (typeof window.matchMedia !== 'function') return undefined;
    const matcher = window.matchMedia(query);
    const update = () => setIsMobile(matcher.matches);
    update();

    if (matcher.addEventListener) {
      matcher.addEventListener('change', update);
      return () => matcher.removeEventListener('change', update);
    }

    matcher.addListener(update);
    return () => matcher.removeListener(update);
  }, [query]);

  return isMobile;
}
